import React from 'react';
import PropTypes from 'prop-types';
import { Link, useRouteMatch } from 'react-router-dom';

import { useTranslation } from '@mssgme/i18n';
import { DeprecatedEditIcon } from '@mssgme/icons';
import { IconButton } from '@mssgme/ui';

import styles from './QuickReplyItem.scss';

export const replyType = PropTypes.shape({
    _id: PropTypes.string.isRequired,
    shortcut: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
});

QuickReplyItem.propTypes = {
    data: replyType.isRequired,
    onSelect: PropTypes.func,
    isEdit: PropTypes.bool,
};

QuickReplyItem.defaultProps = {
    isEdit: false,
};

export default function QuickReplyItem({ data, isEdit, onSelect, ...rest }) {
    const { t } = useTranslation('inbox');
    const { url } = useRouteMatch();

    const handleClick = (e) => {
        e.preventDefault();
        onSelect && onSelect(data);
    };

    return (
        <li className={styles.root} data-replyid={data.shortcut} {...rest}>
            <div className={styles.left} onClick={handleClick}>
                <h4 className={styles.shortcut}>{data.shortcut}</h4>
                <p className={styles.message}>{data.message}</p>
            </div>
            {isEdit && (
                <div className={styles.right}>
                    <IconButton as={Link} to={`${url}/${data._id}`} className={styles.edit}>
                        <DeprecatedEditIcon size={24} title={t('QuickRepliesPopup.editTip')} />
                    </IconButton>
                </div>
            )}
        </li>
    );
}
